"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserQuest = exports.UserQuestReferredEarnedGiftCardProgressMeter = exports.UserQuestDollarsSpentProgressMeter = exports.UserQuestMinutesPlayedProgressMeter = exports.RawTrackedValue = exports.QuestConfig = exports.TimeUnit = exports.QuestUnlockingRules = exports.QuestUnlockingRuleTypesEnum = exports.QuestUnlockingRuleTypes = exports.QuestReferredEarnedGiftCardProgressMeter = exports.QuestDollarsSpentProgressMeter = exports.QuestMinutesPlayedProgressMeter = exports.QuestProgressTypeEnum = exports.QuestProgressType = exports.QuestCategoryEnum = exports.QuestCategory = void 0;
const zod_1 = require("zod");
const types_1 = require("../types");
var QuestCategory;
(function (QuestCategory) {
    QuestCategory["STARTER"] = "STARTER";
    QuestCategory["FLASH"] = "FLASH";
    QuestCategory["WEEKLY"] = "WEEKLY";
})(QuestCategory || (exports.QuestCategory = QuestCategory = {}));
exports.QuestCategoryEnum = zod_1.z.nativeEnum(QuestCategory);
var QuestProgressType;
(function (QuestProgressType) {
    QuestProgressType["MINUTES_PLAYED"] = "MINUTES_PLAYED";
    QuestProgressType["DOLLARS_SPEND"] = "DOLLARS_SPEND";
    QuestProgressType["PLAYBACK_DOLLARS_SPEND"] = "PLAYBACK_DOLLARS_SPEND";
    QuestProgressType["REFERRED_DOLLARS_SPEND"] = "REFERRED_DOLLARS_SPEND";
    QuestProgressType["REFERRED_EARNED_GIFT_CARD"] = "REFERRED_EARNED_GIFT_CARD";
    QuestProgressType["MULTIPLE_QUESTS"] = "MULTIPLE_QUESTS";
})(QuestProgressType || (exports.QuestProgressType = QuestProgressType = {}));
exports.QuestProgressTypeEnum = zod_1.z.nativeEnum(QuestProgressType);
exports.QuestMinutesPlayedProgressMeter = zod_1.z.object({
    eligibleGames: zod_1.z.array(zod_1.z.string()).optional(),
    canTrackMultipleGames: zod_1.z.boolean(),
    isTimerLogicAvailable: zod_1.z.boolean(),
    offersNeededToComplete: zod_1.z.number(),
    onlyNewUAOffersEligible: zod_1.z.boolean().optional(),
    type: zod_1.z.literal(QuestProgressType.MINUTES_PLAYED),
    value: zod_1.z.number(),
});
exports.QuestDollarsSpentProgressMeter = zod_1.z.object({
    eligibleGames: zod_1.z.array(zod_1.z.string()).optional(),
    type: zod_1.z.union([
        zod_1.z.literal(QuestProgressType.PLAYBACK_DOLLARS_SPEND),
        zod_1.z.literal(QuestProgressType.DOLLARS_SPEND),
    ]),
    value: zod_1.z.number(),
});
exports.QuestReferredEarnedGiftCardProgressMeter = zod_1.z.object({
    type: zod_1.z.literal(QuestProgressType.REFERRED_EARNED_GIFT_CARD),
    value: zod_1.z.number(),
});
var QuestUnlockingRuleTypes;
(function (QuestUnlockingRuleTypes) {
    QuestUnlockingRuleTypes["QUESTS_COMPLETED"] = "QUESTS_COMPLETED";
    QuestUnlockingRuleTypes["UA_OFFER_IS_AVAILABLE"] = "UA_OFFER_IS_AVAILABLE";
    QuestUnlockingRuleTypes["PLAYTIME_OFFER_AVAILABLE"] = "PLAYTIME_OFFER_AVAILABLE";
})(QuestUnlockingRuleTypes || (exports.QuestUnlockingRuleTypes = QuestUnlockingRuleTypes = {}));
exports.QuestUnlockingRuleTypesEnum = zod_1.z.nativeEnum(QuestUnlockingRuleTypes);
exports.QuestUnlockingRules = zod_1.z.object({
    entityId: zod_1.z.string().optional(),
    type: exports.QuestUnlockingRuleTypesEnum,
});
exports.TimeUnit = zod_1.z.object({
    unit: zod_1.z.string(),
    value: zod_1.z.number(),
});
exports.QuestConfig = zod_1.z.object({
    id: zod_1.z.string(),
    CTA: zod_1.z.object({ link: zod_1.z.string(), text: zod_1.z.string() }),
    category: exports.QuestCategoryEnum,
    coinsReward: zod_1.z.number(),
    createdAt: types_1.FTimestamp,
    expiredAt: types_1.FTimestamp.nullable(),
    featuredOrdering: zod_1.z.number(),
    ignoreRulesForExistingUsers: zod_1.z.boolean(),
    imageUrl: zod_1.z.string(),
    isNotificationCTAShown: zod_1.z.boolean(),
    isSegment: zod_1.z.boolean(),
    isShownLocked: zod_1.z.boolean(),
    ordering: zod_1.z.number(),
    piggyReward: zod_1.z.number(),
    progressMeter: zod_1.z.union([
        exports.QuestMinutesPlayedProgressMeter,
        exports.QuestDollarsSpentProgressMeter,
        exports.QuestReferredEarnedGiftCardProgressMeter,
    ]),
    questDuration: exports.TimeUnit.optional(),
    questsAmountAvailable: zod_1.z.number().optional(),
    refreshTime: exports.TimeUnit.optional(),
    scheduledStart: exports.TimeUnit.optional(),
    startedAt: types_1.FTimestamp.nullable(),
    subtitle: zod_1.z.string(),
    title: zod_1.z.string(),
    unlockingRules: zod_1.z.array(exports.QuestUnlockingRules),
});
exports.RawTrackedValue = zod_1.z.record(zod_1.z.object({
    completedAt: types_1.FTimestamp.optional(),
    value: zod_1.z.number(),
}));
exports.UserQuestMinutesPlayedProgressMeter = exports.QuestMinutesPlayedProgressMeter.extend({
    rawTrackedValue: exports.RawTrackedValue,
});
exports.UserQuestDollarsSpentProgressMeter = exports.QuestDollarsSpentProgressMeter.extend({
    trackedValue: zod_1.z.number(),
    rawTrackedValue: exports.RawTrackedValue,
});
exports.UserQuestReferredEarnedGiftCardProgressMeter = exports.QuestReferredEarnedGiftCardProgressMeter.extend({
    trackedValue: zod_1.z.number(),
});
exports.UserQuest = zod_1.z.object({
    id: zod_1.z.string(),
    CTA: zod_1.z.object({ link: zod_1.z.string(), text: zod_1.z.string() }),
    category: exports.QuestCategoryEnum,
    claimedAt: types_1.FTimestamp.optional(),
    coinsReward: zod_1.z.number(),
    completedAt: types_1.FTimestamp.nullable(),
    createdAt: types_1.FTimestamp,
    expiredAt: types_1.FTimestamp.nullable(),
    featuredOrdering: zod_1.z.number(),
    ignoreRulesForExistingUsers: zod_1.z.boolean(),
    imageUrl: zod_1.z.string(),
    isNotificationCTAShown: zod_1.z.boolean(),
    isRefreshable: zod_1.z.boolean(),
    isSegment: zod_1.z.boolean(),
    isShownLocked: zod_1.z.boolean(),
    ordering: zod_1.z.number(),
    piggyReward: zod_1.z.number(),
    progressMeter: zod_1.z.union([
        exports.UserQuestMinutesPlayedProgressMeter,
        exports.UserQuestDollarsSpentProgressMeter,
        exports.UserQuestReferredEarnedGiftCardProgressMeter,
    ]),
    questId: zod_1.z.string(),
    startedAt: types_1.FTimestamp,
    subtitle: zod_1.z.string(),
    title: zod_1.z.string(),
    userId: zod_1.z.string(),
});
